<app-spinner-service></app-spinner-service>
<form [formGroup]="editarPagamento" (ngSubmit)="onSubmit()" class="w-auto pt-4 pl-6 pr-6 pb-6">

    <div class="grid p-fluid col-12 mb-3">
        <div class="grid col-12 align-content-center">
            <div class="col-3">
                <label for="pa">Período</label>
                <input id="pa" readonly variant="filled" pInputText
                    [value]="formatCompetencia(editarPagamento.get('pa')?.value)" class="w-full mt-1" />
            </div>

            <div class="col-3">
                <label for="valor">Valor</label>
                <p-inputNumber class="w-full mt-1" inputId="valor" formControlName="valor" mode="currency"
                    currency="BRL" locale="pt-BR" />
            </div>
        </div>

        <div class="col-12 mt-3 flex justify-content-between">
            <div class="col-6 p-0 max-w-10rem">
                <p-button type="button" label="Cancelar" icon="pi pi-times" severity="danger"
                    (click)="onCancel()"></p-button>
            </div>
            <div class="col-6 p-0 max-w-10rem">
                <p-button type="submit" label="Salvar" icon="pi pi-check"
                    [disabled]="editarPagamento.invalid"></p-button>
            </div>
        </div>
    </div>
</form>